"use strict";

import angular from "angular";
import "./themes/request-licenses-dialog.scss";
import "./themes/request-licenses-dark-dialog.scss";
import toastCustomTemplate from "../../../../../../shared/components/nu-toast-custom/toast-custom.component.html";
import { Accounting } from "../../../../../../gateway/Accounting/Accounting";
import { Events } from "../../../../../../presentation/services/Events/Events";
import { RolesUtils } from "../../../../../../utils/roles/roles";

export class RequestLicensesDialogCtrl {
    Accounting = new Accounting();
    Events = new Events();
    page = {
        current: "yearly",
        economyPrice: 0,
        messageEconomy: ""
    };

    valueAnalysisPlus = { countPackage: 0, countIndividual: 0 };

    typesAnalysisPlan = {
        yearly: {
            priceIndividualMonth: 74.17,
            pricePackageMonth: 40.75,
            priceIndividual: 890.0,
            pricePackage: 4890.0
        },
        monthly: {
            pricePackageMonth: 89.0,
            priceIndividualMonth: 0.0,
            priceIndividual: 139.0,
            pricePackage: 890.0
        },
        none: {
            priceMonth: 0.0,
            priceIndividual: 0.0,
            pricePackage: 0.0
        }
    };

    formAnalysisPlan = {
        none: this.valueAnalysisPlus,
        yearly: this.valueAnalysisPlus,
        monthly: this.valueAnalysisPlus,
        none: this.valueAnalysisPlus,
        growRequest: {
            totalIndividualParcel: 0,
            totalPriceIndividual: 0,
            totalPricePackage: 0,
            parcels: 0,
            total: 0,
            acceptDemmand: false
        }
    };

    constructor($mdDialog, locals, toast) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.toast = toast;
    }

    $onInit() {}

    onChangePage() {
        this.valueAnalysisPlus = { countPackage: 0, countIndividual: 0 };

        this.formAnalysisPlan = {
            none: this.valueAnalysisPlus,
            yearly: this.valueAnalysisPlus,
            monthly: this.valueAnalysisPlus,
            none: this.valueAnalysisPlus,
            growRequest: {
                totalPriceIndividual: 0,
                totalPricePackage: 0,
                parcels: 0,
                total: 0,
                acceptDemmand: false
            }
        };

        this.onCalcTotalValue();
    }

    onCalcTotalValue() {
        this.formAnalysisPlan.growRequest.parcels = 0;

        this.setCalcPackage();
        this.setCalcIndividual();
        this.setEconomyPrice();

        const totalValuePriceIndividual = this.formAnalysisPlan.growRequest
            .totalPriceIndividual;
        const totalPricePakcage = this.formAnalysisPlan.growRequest
            .totalPricePackage;

        if (this.page.current === "yearly") {
            this.formAnalysisPlan.growRequest.parcels = 12;
            this.formAnalysisPlan.growRequest.total =
                (totalValuePriceIndividual + totalPricePakcage * 12) / 12;
        } else {
            this.formAnalysisPlan.growRequest.total =
                totalValuePriceIndividual + totalPricePakcage;
        }
    }

    setCalcIndividual() {
        if (this.page.current === "none") return;
        const currentPage = this.formAnalysisPlan[this.page.current || "none"];
        const currentTypeLicense = this.typesAnalysisPlan[
            this.page.current || "none"
        ];

        if (this.page.current === "yearly") {
            this.formAnalysisPlan.growRequest.totalPriceIndividual =
                currentTypeLicense.priceIndividualMonth *
                12 *
                currentPage.countIndividual;

            this.formAnalysisPlan.growRequest.totalIndividualParcel = angular.copy(
                (currentTypeLicense.priceIndividualMonth *
                    12 *
                    currentPage.countIndividual) /
                    12
            );
        } else {
            this.formAnalysisPlan.growRequest.totalPriceIndividual =
                currentTypeLicense.priceIndividual *
                currentPage.countIndividual;
            this.formAnalysisPlan.growRequest.totalIndividualParcel = angular.copy(
                currentTypeLicense.priceIndividual * currentPage.countIndividual
            );
        }
    }

    setCalcPackage() {
        if (this.page.current === "none") return;
        const currentPage = this.formAnalysisPlan[this.page.current || "none"];
        const currentTypeLicense = this.typesAnalysisPlan[
            this.page.current || "none"
        ];

        let resultPrice =
            currentTypeLicense.pricePackageMonth *
            10 *
            currentPage.countPackage;

        this.formAnalysisPlan.growRequest.totalPricePackage = resultPrice;
    }

    onSetCountLicence(countType, typeSummary) {
        const page = this.page.current || "none";

        if (typeSummary === "sum") {
            this.formAnalysisPlan[page][countType] += 1;
        } else if (typeSummary === "sub") {
            this.formAnalysisPlan[page][countType] -= 1;

            if (this.formAnalysisPlan[page][countType] < 0) {
                this.formAnalysisPlan[page][countType] = 0;
            }
        }

        this.onCalcTotalValue();
    }

    needShowMessageEconommy() {
        if (!this.formAnalysisPlan[this.page.current]) return;

        const { countPackage, countIndividual } = this.formAnalysisPlan[
            this.page.current
        ];

        return countPackage > 0 || countIndividual > 0 || false;
    }

    setEconomyPrice() {
        const currentPage = this.formAnalysisPlan[this.page.current];
        const numberOfPackage = 10 * currentPage.countPackage;
        const discountPackage =
            89 * 12 * numberOfPackage - 4890 * currentPage.countPackage;
        const discountIndividual =
            139 * 12 * currentPage.countIndividual -
            890 * currentPage.countIndividual;

        const result = discountPackage + discountIndividual;

        if (this.page.current === "yearly")
            return `Você está economizando
                    <span>${this.toCurrency(result)}</span> escolhendo o
                    plano anual`;
        else {
            return `Você economizaria
                    <span>${this.toCurrency(result)}</span> escolhendo o
                    plano anual`;
        }
    }

    toCurrency(currency) {
        return currency.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }

    async onSubmit() {
        this.loading = true;
        const currentPage = this.formAnalysisPlan[this.page.current];
        const limitLicences =
            currentPage.countPackage * 10 + currentPage.countIndividual;

        const currentPlan = angular.copy(
            this.locals.accountingEntity.props?.plan?.analysisPlus?.limit
        );
        const totalPricePlan = this.toCurrency(
            this.formAnalysisPlan.growRequest.total
        );
        const inputTypes = {
            monthly: "Mensal",
            yearly: "Anual"
        };
        const growData = {
            addedValue: totalPricePlan,
            countCompany: limitLicences,
            period: inputTypes[this.page.current],
            businessPackageTotal: currentPage.countPackage,
            individualLicenseTotal: currentPage.countIndividual,
            additionalValue: totalPricePlan,
            currentPlan
        };
        const hasPermission = RolesUtils.userIsInRole({
            roles: ["Contabilidade"]
        });
        let licenses = 0;
        if (hasPermission) {
            licenses = await this.requestProductGrowth(growData);
        }
        this.$mdDialog.hide({ licenses });
        this.loading = false;
    }

    async requestProductGrowth(growData) {
        try {
            const response = await this.Accounting.requestProductGrowth({
                accountingId: this.locals.accountingEntity.props._id,
                pckge: "analisePlus",
                licenses: growData.countCompany,
                email: this.locals.user.username,
                options: {
                    addedValue: growData.addedValue,
                    period: growData.period
                }
            });
            if (!response?.message) {
                this.toastMessage("Solicitação enviada com sucesso");
                this.Events.send(
                    `grow.dialog.analiseplus.confirma.${growData.period}`
                );
                return growData.countCompany;
            }
            return 0;
        } catch (error) {
            console.log(error);
            return 0;
        }
    }

    toastMessage(toastMessage) {
        this.toast.show("", "bottom right", {
            hideDelay: 3000,
            controllerAs: "ctrl",
            locals: {
                toastMessage,
                action: [
                    {
                        style:
                            "md-icon-button dsn-icon-button dsn-icon-button-medium",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }
}

RequestLicensesDialogCtrl.$inject = ["$mdDialog", "locals", "toast"];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("RequestLicensesDialogCtrl", RequestLicensesDialogCtrl);
